module.exports = __webpack_public_path__ + "img/notification.1a5ba0cc.svg";